module.exports = __webpack_public_path__ + "static/img/GentleNurturer.7796be5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui/reports/GentleNurturer.png
// module id = yac4
// module chunks = 1